if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');

        if (idInput) {
          idInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        if (!this.submitButton) return;

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          true
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] =
          'XMLHttpRequest';

        delete config.headers['Content-Type'];

        const formData =
          new FormData(this.form);

        /*
         * ==========================================
         * CANTIDAD
         * ==========================================
         */

        const quantityInput =
          document.getElementById(
            'hiddenQuantityInput'
          );

        if (quantityInput) {
          formData.set(
            'quantity',
            quantityInput.value
          );
        }

        /*
         * ==========================================
         * SECCIONES NECESARIAS PARA EL DRAWER
         * ==========================================
         */

        formData.set(
          'sections',
          'cart-drawer,cart-icon-bubble'
        );

        formData.set(
          'sections_url',
          window.location.pathname
        );

        config.body = formData;

        /*
         * ==========================================
         * AÑADIR AL CARRITO
         * ==========================================
         */

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => {
            if (!response.ok) {
              throw new Error(
                `HTTP error ${response.status}`
              );
            }

            return response.json();
          })

          .then((response) => {

            /*
             * ======================================
             * ERROR DE SHOPIFY
             * ======================================
             */

            if (response.status) {

              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source: 'product-form',
                  productVariantId:
                    formData.get('id'),
                  errors:
                    response.errors ||
                    response.description,
                  message:
                    response.message,
                }
              );

              this.handleErrorMessage(
                response.description
              );

              const soldOutMessage =
                this.submitButton.querySelector(
                  '.sold-out-message'
                );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton.setAttribute(
                'aria-disabled',
                true
              );

              const buttonText =
                this.submitButton.querySelector(
                  'span'
                );

              if (buttonText) {
                buttonText.classList.add(
                  'hidden'
                );
              }

              soldOutMessage.classList.remove(
                'hidden'
              );

              this.error = true;

              return;
            }

            /*
             * ======================================
             * PRODUCTO AÑADIDO CORRECTAMENTE
             * ======================================
             */

            console.log(
              'Aquabimbi: producto añadido',
              response
            );

            /*
             * Abrir / actualizar drawer
             */

            if (this.cart) {

              /*
               * Si tenemos renderContents,
               * usamos la respuesta con las
               * secciones actualizadas.
               */

              if (
                typeof this.cart.renderContents ===
                'function'
              ) {

                this.cart.renderContents(
                  response
                );

              }

              /*
               * Por seguridad, intentamos abrir
               * el drawer explícitamente.
               */

              setTimeout(() => {

                if (
                  typeof this.cart.open ===
                  'function'
                ) {
                  this.cart.open();
                }

              }, 50);

            } else {

              /*
               * Si no existe drawer,
               * vamos directamente al carrito.
               */

              window.location.href = '/cart';

              return;
            }

            /*
             * ======================================
             * QUITAR LOADING
             * ======================================
             */

            this.submitButton.classList.remove(
              'loading'
            );

            this.submitButton.removeAttribute(
              'aria-disabled'
            );

            if (spinner) {
              spinner.classList.add('hidden');
            }

          })

          .catch((error) => {

            console.error(
              'Aquabimbi Product Form Error:',
              error
            );

            this.submitButton.classList.remove(
              'loading'
            );

            this.submitButton.removeAttribute(
              'aria-disabled'
            );

            if (spinner) {
              spinner.classList.add('hidden');
            }

          });
      }

      handleErrorMessage(errorMessage = false) {

        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            '.product-form__error-message'
          );

        this.errorMessageWrapper.toggleAttribute(
          'hidden',
          !errorMessage
        );

        if (errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    }
  );
}